import { baseApiForNurse } from "./baseApi";

export const classesApi = baseApiForNurse.injectEndpoints({
    credentials: "include",
    endpoints: (builder) => ({
        getClassesByBatchId: builder.query({
            query: (id) => {
                return {
                    url: "/class?batch_id=" + id,
                    method: "GET",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
        }),

        enrollClass: builder.mutation({
            query: (data) => {
                return {
                    url: "class-enrollment",
                    method: "POST",
                    body: data,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
        }),

        attendClass: builder.mutation({
            query: (id) => {
                return {
                    url: "class-enrollment/attend-class/" + id,
                    method: "PUT",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                };
            },
            keepUnusedDataFor: 0,
            refetchOnFocus: true,
        }),
    }),
});

export const {
    useGetClassesByBatchIdQuery,
    useEnrollClassMutation,
    useAttendClassMutation
} = classesApi;
